import ReactECharts from "echarts-for-react";
import { useRef } from "react";
import { AppCard } from "@/layout/AppComponents";

const Report25OnlineInfo = ({ responseData }) => {
  const chartRef = useRef(null);

  const getColorByValue = (data) => {
    const value = Number(data[4]);
    if (value >= 90) return "#006400";
    if (value >= 70) return "#90EE90";
    if (value >= 50) return "#FFD700";
    if (value >= 30) return "#FFA500";
    return "#FF0000";
  };

  const downloadChart = () => {
    const url = chartRef.current?.getDataURL({
      type: "png", // o "jpeg"
      pixelRatio: 2, // mayor resolución
      backgroundColor: "#fff",
    });

    if (!url) return;

    const link = document.createElement("a");
    link.href = url;
    link.download = "grafico.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="row  mt-3">
      <div className="col-xl-12">
        <AppCard>
          <button className="btn btn-sm btn-primary" onClick={downloadChart}>
            Descargar como imagen
          </button>
          <div
            style={{
              width: "80%",
              height: "900px",
              margin: "auto",
            }}
          >
            <ReactECharts
              style={{ width: "100%", height: "100%" }}
              onChartReady={(chart) => {
                chartRef.current = chart;
                chart.resize();
              }}
              option={{
                grid: {
                    right: 300, // px; sube/baja según longitud de nombres
                  },
                xAxis: {
                  type: "value",
                  name: "MI",
                  nameLocation: "middle",
                  splitLine: { show: false },
                  min: 0,
                  max: 100,
                },
                yAxis: {
                  type: "value",
                  name: "CI",
                  nameLocation: "middle",
                  splitLine: { show: false },
                  scale: true,
                  min: 0,
                  max: 100,
                },
                series: [
                  {
                    name: "1990",
                    data: responseData?.onlineInfo,
                    type: "scatter",
                    itemStyle: {
                      color: (params) => getColorByValue(params.data),
                    },
                    symbolSize: (data) => data[2],
                    emphasis: {
                      focus: "self",
                    },
                    labelLayout: () => ({
                      x: chartRef.current?.getWidth() - 300,
                      moveOverlap: "shiftY",
                    }),
                    labelLine: {
                      show: true,
                      length2: 5,
                      lineStyle: {
                        color: "#bbb",
                      },
                    },
                    label: {
                      show: true,
                      formatter: function (param) {
                        return param.data[3];
                      },
                      position: "right",
                      minMargin: 2,
                    },
                  },
                ],
              }}
            />
          </div>
        </AppCard>
      </div>
    </div>
  );
};

export default Report25OnlineInfo;
